import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { VideoChatWithStrangersBanner, SROnlyH1 } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function VideoChatWithStrangers() {
  return (
    <>
      <SEO
        title="Video Chat with Strangers - Talkvee"
        description="Video chat with strangers in seconds. Safety tools, no recordings, and fast matching."
        pathname="/video-chat-with-strangers"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Video Chat with Strangers", "item": "https://talkvee.com/video-chat-with-strangers" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <VideoChatWithStrangersBanner />
        <section className="landing-hero">
          <h1 className="landing-title">Video Chat with Strangers — Fast & Private</h1>
          <p className="landing-subtitle">
            Start a live conversation in seconds. Sessions are not recorded, and our
            guidelines + reporting keep things friendly.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <FAQSection
          items={[
            {
              q: "Do I need a camera to video chat?",
              a: "A camera is best, but you can also join with text-only chat if needed."
            },
            {
              q: "Is my video chat private?",
              a: "Yes. We don’t record or save your streams. Once the chat ends, it’s gone."
            },
            {
              q: "What if my match is inappropriate?",
              a: "You can report them easily. Offenders are banned to keep the community safe."
            },
            {
              q: "Can I play games while video chatting?",
              a: "Yes. Talkvee lets you add trivia battles or laugh challenges while on video."
            },
            {
              q: "Is video chat free?",
              a: "Yes. Talkvee is free, with no ads or charges."
            },
            {
              q: "How fast is the connection?",
              a: "Matches are instant, and we optimize for lightweight streaming even on slower networks."
            },
            {
              q: "Does it work on mobile?",
              a: "Yes, Talkvee supports video chat on both desktop and mobile browsers."
            }
          ]}
        />

      </div>
    </>
  );
}